// ww_worker.js - Web Worker 脚本，仅做计算或数据处理

self.onmessage = function (event) {
  const { type, payload } = event.data;

  if (type === 'ww_sum') {
    let total = 0;
    for (let i = 0; i < 1e7; i++) {
      total += payload.multiplier * i;
    }
    self.postMessage({ type: 'ww_sum_result', result: total });
  }
};
